import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { EntityInterface } from 'common/types/entities/EntityInterface'
import {
  EntityNewInterface,
  EntityWithChildIdsNewInterface,
} from 'src/shared/schemas/entity.schema'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { v4 as uuid } from 'uuid'
import { FormSubEntityTypeEnum } from '../form/enums'

export const generateId = () => uuid()

export const generateHtmlAttrId = (
  entityType:
    | EntityTypeEnum
    | keyof typeof structureTypes
    | FormSubEntityTypeEnum,
) => `${entityType?.toLowerCase().replace('_', '-')}-${uuid().slice(0, 8)}`

export const generateCustomHtmlAttrId = (
  entityType: EntityTypeEnum,
  customString: string,
) =>
  `${entityType?.toLowerCase().replace('_', '-')}-${customString}${uuid().slice(0, 8)}`

export const insertChild = (
  childIds: string[],
  id: string,
  position: number,
) => [...childIds.slice(0, position), id, ...childIds.slice(position)]

/**
 * @deprecated Use the generateEntity or generateEntityWithChildIds instead
 */
export function generateBaseEntity<EntityType extends EntityTypeEnum>(
  type: EntityType,
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  const baseEntity: Omit<EntityInterface, 'type'> & { type: EntityType } = {
    id: generateId(),
    type,
    parentId,
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(type),
  }

  if (masterBlockId) {
    baseEntity.masterBlockId = masterBlockId
  }

  return baseEntity
}

export function generateEntity<EntityType extends EntityTypeEnum>(
  type: EntityType,
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  const entity: Omit<EntityNewInterface, 'type'> & {
    type: EntityType
  } = {
    id: generateId(),
    type,
    parentId,
    htmlAttrId: generateHtmlAttrId(type),
  }

  if (masterBlockId) {
    entity.masterBlockId = masterBlockId
  }

  return entity
}

export function generateEntityWithChildIds<EntityType extends EntityTypeEnum>(
  type: EntityType,
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): Omit<EntityWithChildIdsNewInterface, 'type'> & {
  type: EntityType
} {
  const entity = generateEntity<EntityType>(type, parentId, masterBlockId)

  return {
    ...entity,
    childIds: [],
  }
}
